var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAspas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 28,
    viewBox: "0 0 37 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9C0 16.4333 1.16667 12.7667 3.5 8.9C5.83333 5.16667 8.2 2.53333 10.6 0.999999C11.4667 0.333333 12.5333 0 13.8 0C14.4 0 14.9333 0.199999 15.4 0.599998C15.8667 1 16.1 1.5 16.1 2.1C16.1 2.43334 15.6667 3.1 14.8 4.1C14 5.03333 13 6.46667 11.8 8.4C10.6667 10.3333 9.76667 12.5 9.1 14.9C11.7 15.9667 13 17.9333 13 20.8C13 22.6667 12.3667 24.2333 11.1 25.5C9.83333 26.7 8.26667 27.3 6.4 27.3C4.46667 27.3 2.9 26.6333 1.7 25.3C0.566667 23.9667 0 22.1667 0 19.9ZM21 19.9C21 16.4333 22.1667 12.7667 24.5 8.9C26.7 5.23333 29.0333 2.6 31.5 0.999999C32.3667 0.333333 33.4333 0 34.7 0C36.2333 0 37 0.700001 37 2.1C37.0667 2.43334 36.7 3.06667 35.9 4C35.1 4.93334 34.0667 6.4 32.8 8.4C31.6 10.4 30.6667 12.5667 30 14.9C32.6 15.9667 33.9 17.9333 33.9 20.8C33.9 22.6667 33.2667 24.2333 32 25.5C30.7333 26.7 29.1667 27.3 27.3 27.3C25.3667 27.3 23.8333 26.6333 22.7 25.3C21.5667 23.9667 21 22.1667 21 19.9Z",
    fill: "#F28194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAspas);
export default __webpack_public_path__ + "static/media/aspas.05001792e8350d43a4005eb15e3364ff.svg";
export { ForwardRef as ReactComponent };